import { ReactNode } from 'react';
import styled from '@emotion/styled';

import SelectableContainer, {
  SelectableContainerProps,
} from '@shared/v2/components/SelectableContainer';

export type SelectableCardProps = {
  isSelected?: boolean;
  children: ReactNode;
} & SelectableContainerProps;

const StyledCard = styled(SelectableContainer)`
  display: flex;
  gap: 24px;
`;

const SelectableCard = ({
  isSelected,
  children,
  ...rest
}: SelectableCardProps) => {
  return (
    <StyledCard
      isSelected={isSelected}
      as="article"
      bg="white"
      borderRadius="default"
      py="6"
      px={['4', null, '6']}
      gap="6"
      flexDirection={['column', null, 'row']}
      {...rest}
    >
      {children}
    </StyledCard>
  );
};

export default SelectableCard;
